<template>
  <label class="radio-button">
    <input
      id="option2"
      name="radio-group"
      type="radio"
      :checked="checked"
      @click.stop=""
    />
    <span class="radio-checkmark"></span>
    <span class="radio-label">{{ label }}</span>
  </label>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    label: {
      type: String,
      default: "",
    },
    checked: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">
.radio-button {
  --primary: var(--blue);
  --secondary: var(--dark-blue);

  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  input[type="radio"] {
    display: none;
  }

  .radio-checkmark {
    display: inline-block;
    position: relative;
    width: 18px;
    height: 18px;
    margin-right: 10px;
    border: 1.2px solid var(--stroke-light);
    border-radius: 50%;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: var(--primary);
      transition: all 0.2s ease-in-out;
    }
  }
  input[type="radio"]:checked ~ .radio-checkmark {
    border: 1.2px solid var(--primary);
    background-color: var(--secondary);
    &::before {
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>
